export const createPropertyConstants = {
    CREATE_PROPERTY_PENDING  : 'CREATE_PROPERTY_PENDING',
    CREATE_PROPERTY_FULFILLED: 'CREATE_PROPERTY_FULFILLED',
    CREATE_PROPERTY_REJECTED : 'CREATE_PROPERTY_REJECTED',
};
